import React from 'react'
import { useBrewDetailStore } from '../../state/useBrewDetailStore'
import * as UI from '@brewlogix/blx-ui'

const FoodPairings: React.FC = () => {
    const { foodPairingList, productData } = useBrewDetailStore()

    const anyFoodPairingList = foodPairingList || productData?.style?.foodPairingList
    const anyFoodPairingListFiltered = anyFoodPairingList?.filter((item) => {
        return item.title !== null
    })

    return (
        <div className='col-span-2 flex flex-col gap-2 sm:col-span-1'>
            <span className='text-base font-bold text-gray-300'>Food Pairings</span>
            <div className=' flex flex-wrap gap-1'>
                {anyFoodPairingListFiltered?.length > 0
                    ? anyFoodPairingListFiltered.map((food) => (
                          <UI.Pill
                              key={food.title}
                              label={food.title}
                              customClasses='bg-gray-100 text-base py-1 px-3 text-gray-500'
                          />
                      ))
                    : '--'}
            </div>
        </div>
    )
}

export default FoodPairings
